/**
 * Table headers stick to the page, right under the sticky filter card. The
 * layout measures the card and publishes the offset in this CSS variable.
 */
export const STICKY_TABLE_TOP_VAR = '--sticky-table-top'

/**
 * The header background lives on the row, which a sticky header leaves behind,
 * and its spacer row cannot paint a background, so the card pads the top
 * instead (STICKY_TABLE_CARD).
 */
export const STICKY_TABLE_HEADER =
  'md:sticky top-[var(--sticky-table-top,0px)] z-20 bg-white [&_th]:bg-quaternary'

export const STICKY_TABLE_CARD = 'rounded-xl bg-white px-4 pt-4 shadow-card'
